import React, { useContext } from 'react';

const SportOverviewContext = React.createContext<string>(null);
export default SportOverviewContext;

export const useSportCode = () => {
    return useContext(SportOverviewContext);
};
